import client from './client';

export interface AuditLogItem {
  id: number;
  action: string;
  payload: Record<string, unknown>;
  created_at: string;
}

export interface AuditLogListResponse {
  items: AuditLogItem[];
  total: number;
  limit: number;
  offset: number;
  actions: string[];
}

export interface AuditLogQuery {
  action?: string;
  keyword?: string;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
}

export const listAuditLogs = (params: AuditLogQuery = {}) =>
  client.get<AuditLogListResponse>('/api/audit-logs', { params });
